import { FC } from 'react';
import dynamic from 'next/dynamic';

import styles from './styles.module.scss';
import NavigationContainerDesktop from './NavigationDesktop';

import { IHeader } from '../config/declarations';

const HeaderTopBarDesktop = dynamic(() => import('features/HeaderTopBar').then((mod) => mod.HeaderTopBarDesktop));

const DesktopHeader: FC<IHeader> = ({ header }) => {
  const isSimplifiedHeader = !header.nav && !header.searchBox;

  return (
    <header className={styles.header}>
      <HeaderTopBarDesktop
        topBar={header.top!}
        rating={header.rating}
        auth={header.authorization}
        search={header.searchBox}
        isSimplifiedHeader={isSimplifiedHeader}
      />
      <NavigationContainerDesktop
        search={header.searchBox}
        nav={header.nav}
        logo={header.mainLogo}
        isSimplifiedHeader={isSimplifiedHeader}
      />
    </header>
  );
};

export default DesktopHeader;
